<template>
  <section v-if="hasAccept && message_uuid && loaded">

    <hr class="pb-0 mb-2 mt-2" />

    <span v-if="!meeting_accepted && !meeting_declined">
      <b-button variant="primary" class="btn-fill" @click="DecideMeeting(true)">
        {{ $t("MEETING_ACCEPT") }}
      </b-button>
      <b-button variant="danger" class="btn-fill" @click="DecideMeeting(false)">
        {{ $t("MEETING_DECLINE") }}
      </b-button>
    </span> 
    <span v-if="meeting_accepted">
      {{ $t("YOU_HAVE_ACCEPTED_MEETING") }} {{FormatDateTime(meeting_accept_date)}}
    </span>
    <span v-if="meeting_declined">
      {{ $t("YOU_HAVE_DECLINED_MEETING") }} {{FormatDateTime(meeting_accept_date)}}
    </span>
  </section>
</template>
<script>
export default {
  props: ["message_uuid"],
  data() {
    return {
      hasAccept: false,
      loaded: false,
      meeting_accepted: false,
      meeting_declined: false,
      meeting_accept_date: null
    };
  },
  methods: {
    async DecideMeeting(accepted){
        let dto = {
            message_uuid: this.message_uuid,
            accept: accepted,
            decline: !accepted
        };
        await this.$http.post(`${this.user.hostname}/meeting/accept`,dto);
        this.GetStatus();
    },
    async GetMeetingAccept() {
      try {
        let result = await this.$http.get(this.user.hostname + "/meeting/has-accept/" + this.message_uuid);
        this.hasAccept = result.data;
        await this.GetStatus();
      } catch {
        console.log("Error GetMeetingAccept");
      }        
    },    
    async GetStatus() {
      try {
        let result = await this.$http.get(this.user.hostname + "/meeting/status-accept/" + this.message_uuid);
        this.meeting_accepted = result.data.meeting_accepted;
        this.meeting_declined = result.data.meeting_declined;
        this.meeting_accept_date = result.data.meeting_accept_date;
        this.loaded = true;
      } catch {
        console.log("Error GetStatus");
      }        
    }
  },
  watch: {    
  },
  mounted() {
    this.GetMeetingAccept();
  },
};
</script>
<style lang="css"></style>